import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { initCornerstone } from '../cornerstone/init';
import styles from './ViewerPage.module.css';

/**
 * Empty viewer page for secondary monitors.
 * Waits for a study to be loaded via URL navigation from the primary window.
 */
export default function EmptyViewerPage() {
  const navigate = useNavigate();
  const [csReady, setCsReady] = useState(false);

  useEffect(() => {
    initCornerstone().then(() => setCsReady(true));
  }, []);

  // Listen for hash changes (primary window navigates us to a study)
  useEffect(() => {
    function onHashChange() {
      const hash = window.location.hash;
      if (hash.includes('/viewer/')) {
        // React router will handle it via the HashRouter
        window.location.reload();
      }
    }
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.loading}>
        <div style={{ fontSize: 20, marginBottom: 8 }}>EDGE Viewer</div>
        <div>Waiting for study...</div>
        <div style={{ fontSize: 12, marginTop: 16, opacity: 0.5 }}>
          Open a study from the worklist to display it here
        </div>
      </div>
    </div>
  );
}
